import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface CompanyServiceInterface {
  codEmpresa?: number;
  token: string;
  reqBody?: ReqBodyType;
  codUsu?: string;
  perfilUsu?: string | number;
  tipoSelecao?: string | number;
}

class CompanyService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  getCompanyData = async ({
    codEmpresa,
    tipoSelecao = 1,
    codUsu,
    perfilUsu,
    token,
  }: CompanyServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadCliEmpresa?codEmpresa=${codEmpresa}&tipoSelecao=${tipoSelecao}&codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
    });
  };

  editCompany = async ({
    token,
    reqBody,
    codUsu,
    perfilUsu,
  }: CompanyServiceInterface) => {
    return this.httpClient.put({
      token,
      path: `/api/SMob_CadCliEmpresa?codUsu=${codUsu}&perfilUsu=${perfilUsu}`,
      reqBody,
    });
  };

  getActiveCompaniesList = async ({
    token,
    codUsu,
    codEmpresa,
    perfilUsu,
  }: CompanyServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadCliEmpresa?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoSelecao=1&codEmpresa=${codEmpresa}`,
    });
  };

  getLockedCompaniesList = async ({
    token,
    codUsu,
    codEmpresa,
    perfilUsu,
  }: CompanyServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_CadCliEmpresa?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoSelecao=2&codEmpresa=${codEmpresa}`,
    });
  };

  getServicesOptions = async ({
    token,
    codUsu,
    codEmpresa,
    perfilUsu,
  }: CompanyServiceInterface) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_ListasGerais?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoAcao=14&codEmpresa=${codEmpresa}`,
    });
  };

  unlockCompany = async ({
    token,
    codUsu,
    codEmpresa,
    perfilUsu,
  }: CompanyServiceInterface) => {
    return this.httpClient.put({
      token,
      path: `/api/SMob_CadCliConfig?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&tipoAcao=15`,
    });
  };

  lockCompany = async ({
    token,
    codUsu,
    codEmpresa,
    perfilUsu,
  }: CompanyServiceInterface) => {
    return this.httpClient.put({
      token,
      path: `/api/SMob_CadCliConfig?codUsu=${codUsu}&perfilUsu=${perfilUsu}&codEmpresa=${codEmpresa}&tipoAcao=16`,
    });
  };
}

export default new CompanyService();
